import React from "react";
import {formatDate, getTournamentPhaseLabel} from "./tournamentViewUtils";

const TournamentSelectionItem = ({
    tournament,
    isActive,
    onToggle,
    isAdmin,
    children,
}) => {

    return (
        <div
            onClick={onToggle}
            className={`tournament-item ${isActive ? "tournament-item-active" : ""}`}
            style={{
                padding: isActive ? "8px 12px" : "12px 16px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                backgroundColor: isActive ? "#e8f5e8" : "#fff",
                cursor: "pointer",
                transition: "all 0.2s ease",
                borderColor: isActive ? "#4CAF50" : "#ddd",
                marginBottom: "8px",
            }}
            title={isActive ? "Erneut klicken, um dieses Turnier zu deaktivieren" : "Turnier aktivieren"}
            onMouseEnter={(event) => {
                if (!isActive) {
                    event.currentTarget.style.backgroundColor = "#f5f5f5";
                }
            }}
            onMouseLeave={(event) => {
                if (!isActive) {
                    event.currentTarget.style.backgroundColor = "#fff";
                }
            }}
        >
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px"}}>
                <div>
                    <div style={{fontWeight: "bold", color: "#333", fontSize: isActive ? "15px" : "18px"}}>{tournament.name}</div>
                    {!isActive && tournament.description && (
                        <div style={{fontSize: "14px", color: "#666", marginTop: "4px"}}>{tournament.description}</div>
                    )}
                </div>
                {isActive && (
                    <span className="groupphase-status-badge groupphase-status-badge--success">
                        aktiv
                    </span>
                )}
            </div>
            <div className="groupphase-status-row">
                <span className="groupphase-status-badge">
                    {getTournamentPhaseLabel(tournament)}
                </span>
                {tournament.registered && (
                    <span className="groupphase-status-badge groupphase-status-badge--success">
                        angemeldet
                    </span>
                )}
                {tournament.winnerTeamName && (
                    <span className="groupphase-status-badge groupphase-status-badge--success">
                        Sieger: {tournament.winnerTeamName}
                    </span>
                )}
            </div>
            {!isActive && (
                <>
                    <div style={{fontSize: "12px", color: "#777", marginTop: "8px", display: "flex", gap: "16px", flexWrap: "wrap"}}>
                        <span><strong>CourtGroup:</strong> {tournament.courtGroupName || "N/A"}</span>
                        {isAdmin && tournament.teamSize > 1 && !tournament.started ? (
                            <span>
                                <strong>Teams:</strong>{" "}
                                <span style={{color: "#4CAF50"}}>{tournament.numberOfCompleteTeams} vollständig</span>
                                {tournament.numberOfIncompleteTeams > 0 && (
                                    <span style={{color: "#e65100", marginLeft: 6}}>
                                        · {tournament.numberOfIncompleteTeams} unvollständig
                                    </span>
                                )}
                            </span>
                        ) : (
                            <span><strong>Teams:</strong> {tournament.numberOfTeams}</span>
                        )}
                        <span><strong>Spieler pro Team:</strong> {tournament.teamSize || 1}</span>
                        <span><strong>Gruppen:</strong> {tournament.numberOfGroups}</span>
                    </div>
                    {isAdmin && tournament.teamSize > 1 && !tournament.started && tournament.numberOfIncompleteTeams > 0 && (
                        <div style={{fontSize: "12px", color: "#e65100", marginTop: "4px"}}>
                            ⚠ {tournament.numberOfIncompleteTeams} Team{tournament.numberOfIncompleteTeams !== 1 ? "s sind" : " ist"} noch unvollständig – das Turnier kann erst gestartet werden, wenn alle Teams vollständig sind.
                        </div>
                    )}
                    <div className="groupphase-date-grid">
                        <span><strong>Meldeschluss:</strong> {formatDate(tournament.registrationDeadline)}</span>
                        <span><strong>Ende:</strong> {formatDate(tournament.endDate)}</span>
                    </div>
                </>
            )}
            {children ? (
                <div style={{marginTop: "12px", paddingTop: "12px", borderTop: "1px solid rgba(76, 175, 80, 0.25)"}}>
                    {children}
                </div>
            ) : null}
        </div>
    );
};

export default TournamentSelectionItem;


